import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PinExchangeLayout from './PinExchangeLayout';
import PinExchangeHome from './PinExchangeHome';
import PinExchangeDashboard from './PinExchangeDashboard';
import PinMonitoringList from './PinMonitoringList';
import PinCustomerDetail from './PinCustomerDetail';

const PinExchange = ({ posConfig }) => {
    return (
        <Routes>
            <Route path="/" element={<PinExchangeLayout />}>
                <Route index element={<PinExchangeHome posConfig={posConfig} />} />
                <Route path="dashboard" element={<PinExchangeDashboard posConfig={posConfig} />} />
                <Route path="monitor" element={<PinMonitoringList posConfig={posConfig} />} />
                <Route path="customer/:kdnr" element={<PinCustomerDetail posConfig={posConfig} />} />
            </Route>
        </Routes>
    );
};

export default PinExchange;
